import React from 'react';
import ToolLayout from './ToolLayout';
import { Button } from '../components/ui/button';
import { buildDashboardUrl } from '../lib/subdomain';

// Placeholder rendered for any tool whose page has not been built yet.
// When a real implementation lands, swap this out for the tool's own component
// in App.js (or via a `component` field in registry.js if we introduce lazy loading).
function ComingSoon({ tool }) {
  return (
    <ToolLayout tool={tool}>
      <div className="rounded-xl border border-dashed border-border p-10 text-center bg-card">
        <div className="text-3xl mb-3" aria-hidden>🚧</div>
        <h2 className="text-xl font-semibold">We're building this tool</h2>
        <p className="mt-2 text-sm text-muted-foreground max-w-md mx-auto">
          {tool.name} is on its way. In the meantime, explore the other free PDF tools in the suite.
        </p>
        <div className="mt-6">
          <Button asChild className="bg-orange-500 hover:bg-orange-600">
            <a href={buildDashboardUrl()}>Back to all tools</a>
          </Button>
        </div>
      </div>
    </ToolLayout>
  );
}

export default ComingSoon;
